<template>
  <div style="height:100%">
    <!-- <p style="font-size:24px;margin-top:180px;text-align:center">已打开流程页面，请留意新窗口。</p> -->
    <Button type="primary" @click="navigate" style="margin-bottom:12px">新增</Button>
    <Table :columns="columns" :data="tableData" style="min-width:1000px"></Table>
  </div>
</template>

<script>
import axios from 'axios'
import { formatDate } from '@/lib/tool'
export default {
  data() {
    return {
      columns: [
        {
          title: "流水号",
          key: "流水号",
          align: "center",
        },
        {
          title: "责任中心",
          key: "责任中心",
          align: "center",
        },
        {
          title: "发起人",
          key: "发起人（接口用）",
          align: "center"
        },
        {
          title: "预算开始时间",
          key: "预算开始时间",
          align: "center",
          render: (h,params) => {
            return h('div', formatDate(params.row['预算开始时间']))
          }
        },
        {
          title: "上期实际使用资金",
          key: "上期实际使用资金",
          align: "center",
        },
        {
          title: "上期账户余额",
          key: "上期账户余额",
          align: "center",
        },
        {
          title: "本期所需资金计划合计",
          key: "本期所需资金计划合计",
          align: "center",
        },
        {
          title: "本期审批通过资金计划",
          key: "本期审批通过资金计划",
          align: "center",
        },
        {
          title: "流程状态",
          align: "center",
          render: (h, params) => {
            return h('div', {
              style: {
                color: '#f50'
              }
            },
            params.row.flowState ? '已结束' : '进行中')
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    window.open('https://rwisbgxd7e.jiandaoyun.com/q/5fc49dcb341d510007457bf6')
                  }
                }
              }, '详情'),
            ]);
          }
        }
      ],
      tableData: []
    }
  },
  async created() {
    // 简道云数据获取 中间件
    // axios.get(`http://192.168.175.167:8088/jiandaoyun_getData`,{
    axios.get(`http://8.129.89.115:8088/jiandaoyun_getData`,{
      params: {
        creator: this.$store.state.session.user.name
      }
    }).then(res => {
      this.tableData = res.data.result
    })
  },
  methods: {
    navigate () {
      window.open('https://www.jiandaoyun.com/dashboard#/app/5dcceef4e332570006fc5544/form/5fc49dcb341d510007457bf5')
    }
  }
};
</script>

<style lang="less" scoped>
</style>